module.exports = __webpack_public_path__ + "media/theme/tutorial__reco--5--create-853186b1.png";